

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache } from '../../General/Actions.js';
import Swal from 'sweetalert2';

class CustomerSupportComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentActiveSubMenu: "OVERVIEW",
            isFloatingSubMenuVisible: false,
            currentTab: "bundles"
        }
    }

    componentDidMount() {
        this.props.setCache("isAddFnFAddon",this.props.feature)
        window.addEventListener('scroll', this.handleScroll);
        this.initializeQuerySubscriber(this.props.cache.querySubscriberResponse);
        if(this.props.feature === "addAddon"){
            var currentServiceDetails = this.props.cache.dataForMyAccountRedirection
            this.subMenuClicked(currentServiceDetails.type,currentServiceDetails.serviceId,currentServiceDetails.serviceAddress);
        } else if(this.props.feature === "addFnFAddon"){
            var currentServiceDetails = this.props.cache.dataForMyAccountRedirection
            this.subMenuClicked(currentServiceDetails.type,currentServiceDetails.serviceId,currentServiceDetails.serviceAddress);
        }
    }

    initializeQuerySubscriber(receivedResponse) {
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }

        var firstName = "";
        var lastName = "";
        var finalContactNumber = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id  === "first_name") {
                firstName = params[i].value;
            }
            if (params[i].id  === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id  === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
        }
        this.setState({
            billingName: firstName+" "+lastName,
            contactNumber: finalContactNumber
        });
        try{
            var accountInfo = receivedResponse;
            var accountInfoParams =accountInfo.account_info.param;
            var finalAccountId = "";
            for (var j = 0; j < accountInfoParams.length; j++) {
                if (accountInfoParams[j].id  === "account_id") {
                    finalAccountId = accountInfoParams[j].value;
                }
            }
            this.setState({
                accountId: finalAccountId
            });
        } catch(err){

        }
    }

    handleScroll = (event) => {
        if (window.scrollY > 190) {
            this.setState({ isFloatingSubMenuVisible: true });
        } else {
            this.setState({ isFloatingSubMenuVisible: false });
        }
    }

    generalBtnClicked(type){
        this.setState({currentTab: type})
    }

    sendEmail(){
        window.open('mailto:telecomsupport@apua.ag')
    }

    makeCall(){
        window.open('tel:(268) 480-7375')
    }


    subMenuClicked = (type,receivedServiceId,serviceAddress,isAddFnFAddon) => {
        this.setState({ currentActiveSubMenu: type,serviceId:receivedServiceId, serviceAddress:serviceAddress, isAddFnFAddon: isAddFnFAddon});
        // if (window.scrollY > 0) {
        //     window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        //     setTimeout(() => {
        //         this.setState({ currentActiveSubMenu: type });
        //     }, 500);
        // } else {
        //     this.setState({ currentActiveSubMenu: type });
        // }
    }

    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center">
                <div id="CustomerSupportComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : this.customerSupportContentPart()}
                </div>
            </div>
        );
    }

    customerSupportContentPart() {
        return <div className='col-md-12 m-0 p-0 row justify-content-center' style={{flex: 1}}>
            <div className='rechargeCardTopMiniCardInactive col-md-2 col-sm-12 p-4 m-1 justify-content-center' style={{cursor: 'pointer'}} onClick={() => this.makeCall()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="86.985" height="86.992" viewBox="0 0 86.985 86.992">
                <path id="Path_3493" data-name="Path 3493" d="M1767.92,3408.44a3.2,3.2,0,0,1-.96,2.35c-2.19,2.19-3.49,3.5-6.48,6.49-21.47,21.47-97.23-54.28-75.75-75.76l6.48-6.48a3.168,3.168,0,0,1,2.36-.96,3.133,3.133,0,0,1,2.33,1.01l19.33,20.15a3.3,3.3,0,0,1-.05,4.6l-9.12,9.11c6.17,11.11,15.33,19.98,26.98,26.98l9.12-9.11a3.278,3.278,0,0,1,4.59-.05l20.16,19.33a3.192,3.192,0,0,1,1.01,2.34Z" transform="translate(-1680.935 -3334.08)" fill="#fff" fill-rule="evenodd"/>
                </svg>
                <div className='supportCardTxt p-2'>Call us</div>
            </div>
            <div className='rechargeCardTopMiniCardInactive col-md-2 col-sm-12 p-3 m-1' style={{cursor: 'pointer'}} onClick={() => this.sendEmail()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="101.4" height="67.68" viewBox="0 0 101.4 67.68">
                <g id="Group_3579" data-name="Group 3579" transform="translate(-672.3 -536.4)">
                    <path id="Path_3494" data-name="Path 3494" d="M2009.49,3389.74l-28.26,26.8v-49.93Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                    <path id="Path_3495" data-name="Path 3495" d="M2082.63,3366.61v49.56l-28.05-26.61Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                    <path id="Path_3496" data-name="Path 3496" d="M2077.86,3421.08h-91.47l28.44-26.98,17.1,14,17.31-14.16Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                    <path id="Path_3497" data-name="Path 3497" d="M2082.63,3353.4v4.34l-50.7,41.5-50.7-41.5v-4.34Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                </g>
                </svg>
                <div className='supportCardTxt p-2'>Mail us</div>

            </div>
            <div className='rechargeCardTopMiniCardInactive col-md-2 col-sm-12 p-3 m-1 justify-content-center' style={{cursor: 'pointer'}} onClick={() => { Swal.fire("Our customer care number is ", "(268) 480-7375 or 611", ""); }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="62.53" height="93.14" viewBox="0 0 62.53 93.14">
                <path id="Path_3498" data-name="Path 3498" d="M2325.12,3371.33l.66-.66c16.69-.53,24.3-5.91,24.3-14.58v-.26c0-7.36-5.65-12.48-15.11-12.48-8.28,0-15.11,3.68-21.41,10.38l-9.85-10.51c7.62-8.67,17.47-14.58,31.66-14.58,18.39,0,30.87,10.25,30.87,26.67v.26c0,16.55-11.96,24.04-26.54,26.54l-1.31,10.51h-10.64l-2.63-21.28Zm-1.18,32.32h17.6v18.13h-17.6Z" transform="translate(-2303.71 -3328.64)" fill="#fff"/>
                </svg>
                <div className='supportCardTxt p-2'>Service Request</div>
            </div>
        </div>
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        }
    }
}

const CustomerSupportComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerSupportComponent)

export default CustomerSupportComponentContainer;
